<div class="kr-monthly-report__header" data-testid="monthly_report_header">
  <h4 class="kr-monthly-report__title" data-testid="monthly_report_title">
    {{ 'monthlyReport.title' | translate }}
  </h4>

  <button
    class="kr-monthly-report__btn-close"
    data-testid="monthly_report_close_button"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    (click)="close()">
    <fu-icon
      data-testid="monthly_report_close_icon"
      iconName="close-square"></fu-icon>
  </button>
</div>

<div class="kr-monthly-report__body" data-testid="monthly_report_body">
  <kr-status-icon
    data-testid="monthly_report_status_icon"
    iconName="document"
    size="small"
    status="info" />

  <p class="kr-monthly-report__info" data-testid="monthly_report_info">
    {{ 'monthlyReport.info' | translate }}
  </p>

  <form
    class="kr-monthly-report__form"
    [formGroup]="form"
    (ngSubmit)="save()"
    data-testid="monthly_report_form">
    <div
      class="kr-monthly-report__controls"
      data-testid="monthly_report_controls">
      <kr-search-select
        data-testid="monthly_report_provider_type"
        [control]="form.controls.providerId"
        [items]="providerTypes()"
        [placeholder]="'fu.select.placeholder' | translate"
        [label]="'transactions.filters.providerType' | translate"
        [withSearch]="false"
        [multi]="false" />

      <fu-select
        data-testid="monthly_report_month_select"
        formControlName="month"
        [items]="months"
        [label]="'monthlyReport.control.month' | translate">
      </fu-select>

      <fu-select
        data-testid="monthly_report_year_select"
        formControlName="year"
        [items]="years()"
        [label]="'monthlyReport.control.year' | translate">
      </fu-select>
    </div>

    <div class="kr-actions" data-testid="monthly_report_actions">
      <button
        type="button"
        fuButton
        size="m"
        uiType="secondary"
        (click)="close()"
        translate="monthlyReport.btn.cancel"
        data-testid="monthly_report_cancel_button"></button>

      <button
        type="submit"
        fuButton
        size="m"
        uiType="primary"
        [disabled]="form.invalid"
        translate="monthlyReport.btn.generate"
        data-testid="monthly_report_generate_button"></button>
    </div>
  </form>
</div>
